<template>
  <div class="directory-filter">
    <CCard>
      <CCardBody>
        <div>
          <div class="mb-3">
            <TextInput
                  name="ai_search"
                  :value="input['ai_search']"
                  placeholder="Type your AI search here"
                  @input="handleInput"
                />
          </div>
          <div class="mb-3 border-bottom">
            <h5>Find a Partner</h5>
            <CRow name="find-a-partner" class="mb-3">
              <div class="col-lg-8 col-md-8 col-sm-8">
                <TextInput
                  name="find_partner"
                  :value="input['find_partner']"
                  placeholder="search"
                  @input="handleInput"
                />
              </div>
              <div class="col-lg-4 col-md-4 col-sm-4">
                <CButton color="primary" @click="emitFilterAction"
                  >Search</CButton
                >
              </div>
            </CRow>
          </div>
          <div class="mb-3 border-bottom">
            <h5>Partner Type</h5>
            <div v-for="value in options['classifications']" :key="value">
              <label>
                <input
                  :class="`${value}__input`"
                  :value="value"
                  v-model="input['classifications']"
                  type="checkbox"
                  @change="handleCheckBox"
                />
                {{ value }}
              </label>
              <small class="has-error"></small>
            </div>
          </div>
          <div class="mb-3">
            <h5>REGION</h5>
            <Select
              name="region"
              :value="input['region']"
              :options="options && options['region'] ? options['region'] : []"
              @input="handleSelect"
              @change="emitFilterAction"
            />
          </div>
        </div>
        <div class="d-flex justify-content-between">
          <CButton color="secondary" variant="outline" @click="clearFilter"
            >Clear</CButton
          >
          <CButton color="primary" @click="emitFilterAction">Search</CButton>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import TextInput from "@/components/reusable/Fields/TextInput";
import CheckBox from "../../../components/reusable/Fields/CheckBox.vue";
import Select from "../../../components/reusable/Fields/Select.vue";
import { mapGetters, mapActions } from "vuex";
import Vue from "vue";
export default {
  name: "DirectoryFilter",
  data() {
    return {
      input: {
        ai_search: "",
        find_partner: "",
        classifications: [],
        region: "",
      },
      value: {
        ai_search: "",
        find_partner: "",
        classifications: [],
        region: "",
      }
    };
  },
  created() {
    this.locationRegion();
  },
  components: {
    TextInput,
    CheckBox,
    Select,
  },
  computed: {
    ...mapGetters(["getLocationRegion"]),
    preferredRegion() {
      const locationRegion = this.getLocationRegion
        ? this.getLocationRegion
            .map((val) => ({
              label: val.region_name,
              code: val.region_id,
              job_only: val.job_only,
            }))
            .filter((val) => {
              return val.job_only != true;
            })
        : [] || [];
      locationRegion.unshift({
        label: "All",
        code: 0,
      });
      return locationRegion;
    },
    options() {
      return {
        classifications: [
          "Hospital/Clinic",
          "Pharmaceuticals",
          "Education",
          "Governmental",
          "Regulatory Body",
          "Service Provider",
          "Consulting",
          "Supplier",
        ],
        region: this.preferredRegion,
      };
    },
  },
  methods: {
    ...mapActions(["locationRegion"]),
    handleCheckBox(element) {
      this.value['classifications'] = this.input['classifications'];
      this.emitFilterAction();
    },
    emitFilterAction() {
      this.$emit("filterAction", this.value);
    },
    handleSelect(key, value) {
      Vue.set(this.input, key, value);
      this.value[key] = value?.label;
    },
    handleInput(key, value) {
      this.input[key] = value;
      this.value[key] = value;
    },
    clearFilter() {
      this.input = {
        find_partner: "",
        classifications: [],
        region: "",
      };
      this.value = {
        find_partner: "",
        classifications: [],
        region: "",
      };
      this.emitFilterAction();
    },
  },
};
</script>
<style lang="scss" scoped></style>
